import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { shipShipmentNow } from 'redux/clubMemberShipments/actions';

const ShipItNow = (props) => {
  const { clubMembership, clubPackage, clubMemberShipment } = props;
  const dispatch = useDispatch();

  const process = (e) => {
    e.preventDefault();
    const { history } = props;
    const successFunction = (newClubMemberShipment) => {
      history.push(`/profile/order-history/${newClubMemberShipment.orderId}`);
    };
    dispatch(shipShipmentNow(clubMemberShipment.id, successFunction));
  };
  if (
    clubPackage.status === 'Active' &&
    clubPackage.allowCustomersToShipEarly &&
    clubMemberShipment.processingStatus === 'Pending' &&
    clubMembership.customerCreditCard
  ) {
    if (
      clubMembership.shipTo &&
      clubMembership.orderDeliveryMethod === 'Ship'
    ) {
      return (
        <>
          <br />
          <a onClick={process} className="c7-button-small">
            Ship it now
          </a>
          <br />
          <br />
        </>
      );
    }
    return null;
  }

  return null;
};

export default withRouter(ShipItNow);
